import { ukTimeOf } from "@/constants/sheriffOptions"

export function formatTo24HourTime(value?: string | Date | null): string | undefined {
  if (!value) return undefined

  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) return undefined

  return ukTimeOf(date)
}
